import { AppRightBar } from './AppRightBar'
import { useAppSelector } from '../../hooks/useAppSelector'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { selectRightBar } from '../../store/selectors/rightBarSelector'
import { hideRightBar, rightBarButtonsShake } from '../../store/actions/rightBarActions'

export const RightBar = () => {
    const dispatch = useAppDispatch()
    const {
        rightBarHidden,
        rightBarItem,
        fullScreen,
        actionsBar,
        scheduleBar,
        disableHideOnBackdropClick,
    } = useAppSelector(selectRightBar)

    const handleClick = (): void => {
        if (disableHideOnBackdropClick) {
            dispatch(rightBarButtonsShake(true))
            setTimeout(() => dispatch(rightBarButtonsShake(false)), 700)
        }
        if (!disableHideOnBackdropClick) dispatch(hideRightBar())
    }

    return (
        <AppRightBar
            className={`${fullScreen && 'app-rightbar-full-screen'} ${
                actionsBar && 'app-actions-bar'
            } ${scheduleBar && 'app-schedule-bar'}`}
            hidden={rightBarHidden}
            items={rightBarItem}
            onClick={handleClick}
            nonResizable={!!scheduleBar}
        />
    )
}
